<template>
  <div class>
    <!-- header -->
    <div class="main-wrapper-1">
      <header>
        <div>
          <b-navbar type="dark" class="main-wrapper" variant>
            <b-navbar-brand href="#">
              <img
                src="../../assets/images/rubylogonew.png"
                class="d-inline-block align-to img-fluid-home"
                alt="logo"
                width="60px"
              />
              <!-- <span>BootstrapVue</span> -->
            </b-navbar-brand>

            <b-navbar-toggle
              class="nav-toggle"
              target="nav-collapse"
            ></b-navbar-toggle>

            <b-collapse id="nav-collapse" class is-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto nav-bg">
                <b-nav-item class="nav-item" href="#About">
                  <span class="text-color">About</span>
                </b-nav-item>
                <b-nav-item class="nav-item" href="#" @click="ShowLogin = true">
                  <span class="text-color">Login</span>
                </b-nav-item>
                <!-- <b-nav-item
                  class="nav-item"
                  href="#"
                  @click="ShowSignup = true"
                >
                  <span class="text-color join">
                    Join
                    <span class="d-none d-sm-inline">Platform</span>
                  </span>
                </b-nav-item>-->
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </header>

      <div class="middle main-wrapper">
        <div class="row">
          <div class="col-md-6 mb-5">
            <div class="content">
              <h1>
                Online Microfinance
                <br />Banking Solution
              </h1>
              <p>
                Lorem ipsum, dolor sit amet consectetur
                <br />adipisicing elit. Laboriosam molestias ipsa fuga!
                <br />Aspernatur suscipit et vel provident
              </p>

              <button @click="ShowSignup = true" class="btn btn-primary">
                Join Platform
              </button>
            </div>
            <div class="building mt-5 ml-5">
              <div class="img-wrapper">
                <img
                  src="../../assets/images/city.png"
                  alt
                  class="image-fluid city-img d-none d-sm-block"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6 mt-5 mt-lg-0 mx-3 mx-md-0">
            <div class="img-wrapper">
              <img
                src="../../assets/images/ladyrednew.png"
                alt
                class="image-fluid man-img"
              />
            </div>
          </div>
        </div>
        <!-- <div class="d-flex justify-content-end">
          <div class>
            <div class="diamond-wrapper">
              <div id="diamond"></div>
            </div>
            <p class="tme-text">
              <span class="big">
                TME
                <span class="online">Online</span>
              </span>
              <br />
              <span class="small">Microfinance Banking Solution</span>
            </p>
          </div>
          <div class>
            <div class="img-wrapper">
              <img
                src="../../assets/images/ladyRed.png"
                alt
                class="image-fluid man-img d-none d-sm-block"
              />
            </div>
          </div>
          <div class>
            <img
              src="../../assets/images/city.png"
              class="city-img image-fluid d-none d-sm-block"
              alt
            />
            <img
              src="../../assets/images/ladyRed.png"
              class="man-img-1 image-fluid d-block d-sm-none"
              alt
            />
          </div>
        </div>-->
      </div>

      <div class="body main-wrapper">
        <div class="about-tme row">
          <div class="col-md-6 about-wrapper1">
            <p class="about-text h5">About TME</p>

            <p class>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nulla
              nihil voluptatum, rem pariatur modi aperiam, placeat dolorum
              repudiandae adipisci quo temporibus expedita, et quaerat
              repellendus commodi accusantium asperiores dolorem debitis?
            </p>
            <p class>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nulla
              nihil voluptatum, rem pariatur modi aperiam, placeat dolorum
              repudiandae adipisci quo temporibus expedita, et quaerat
              repellendus commodi accusantium asperiores dolorem debitis?
            </p>
            <p class>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nulla
              nihil voluptatum, rem pariatur modi aperiam, placeat dolorum
              repudiandae adipisci quo temporibus expedita, et quaerat
              repellendus commodi accusantium asperiores dolorem debitis?
            </p>
            <p class>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nulla
              nihil voluptatum, rem pariatur modi aperiam, placeat dolorum
              repudiandae adipisci quo temporibus expedita, et quaerat
              repellendus commodi accusantium asperiores dolorem debitis?
            </p>
          </div>

          <div class="col-md-6 about-wrapper1">
            <p class="about-text h5">About TME</p>

            <p class>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nulla
              nihil voluptatum, rem pariatur modi aperiam, placeat dolorum
              repudiandae adipisci quo temporibus expedita, et quaerat
              repellendus commodi accusantium asperiores dolorem debitis?
            </p>
            <p class>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nulla
              nihil voluptatum, rem pariatur modi aperiam, placeat dolorum
              repudiandae adipisci quo temporibus expedita, et quaerat
              repellendus commodi accusantium asperiores dolorem debitis?
            </p>
            <p class>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nulla
              nihil voluptatum, rem pariatur modi aperiam, placeat dolorum
              repudiandae adipisci quo temporibus expedita, et quaerat
              repellendus commodi accusantium asperiores dolorem debitis?
            </p>
            <p class>
              Lorem, ipsum dolor sit amet consectetur adipisicing elit. Nulla
              nihil voluptatum, rem pariatur modi aperiam, placeat dolorum
              repudiandae adipisci quo temporibus expedita, et quaerat
              repellendus commodi accusantium asperiores dolorem debitis?
            </p>
          </div>
        </div>
      </div>

      <!-- Signin modal -->
      <b-modal hide-footer v-model="ShowLogin" size="lg">
        <div class="row">
          <div class="col-lg-6 mt-3">
            <div class="modal-container text-cente">
              <span class="welcome-text h2 px-2">Welcome Back!</span>
              <br />
              <!-- <span class="mt-3 text-center mb-3">Login</span> -->
              <div class="mt-5">
                <form action @submit.prevent="Login">
                  <input
                    type="email"
                    class="form-control mb-4 email1"
                    placeholder="USERNAME"
                  />
                  <input
                    type="password"
                    class="form-control mb-4"
                    placeholder="PASSWORD"
                  />
                  <router-link to="#" class="float-right transaction-title mb-3"
                    >Forgot password</router-link
                  >
                  <input
                    type="submit"
                    value="LET'S GO"
                    class="btn btn-primary btn-block"
                  />
                </form>
                <p class="text-center mt-5">
                  <router-link class="reset-password" to="#"
                    >Reset Password</router-link
                  >
                </p>
              </div>

              <div></div>
            </div>
          </div>
          <div class="col-lg-6 man-col">
            <div class="img-wrapper">
              <img
                src="../../assets/images/loginimg.png"
                alt
                class="image-fluid man-img-2 d-none d-lg-block"
              />
            </div>
          </div>
        </div>
      </b-modal>

      <!-- Signup modal -->
      <b-modal hide-footer v-model="ShowSignup" size="lg">
        <div class="row">
          <div class="col-lg-6">
            <div class="modal-container">
              <span class="welcome-text px-2">Join Platform!</span>
              <!-- <span class="mt-3 text-center mb-3">Login</span> -->
              <div class="mt-2 mx-4">
                <form @submit.prevent="Signup">
                  <div class="row mb-3">
                    <input
                      type="text"
                      v-model="firstname"
                      class="form-control"
                      placeholder="Firstname"
                      required
                    />
                  </div>

                  <div class="row mb-3">
                    <input
                      type="text"
                      v-model="lastname"
                      class="form-control"
                      value
                      placeholder="Lastname"
                      required
                    />
                  </div>

                  <div class="row mb-3">
                    <select
                      v-model="title"
                      class="form-control col-md-3 mb-3 mb-sm-0"
                      placeholder = "title"
                      name="title"
                    >
                      <option value="">Title</option>
                      <option value="Mr">Mr.</option>
                      <option value="Mrs">Mrs.</option>
                      <option value="Ms">Ms</option>
                    </select>
                    <div class="col-md-2"></div>
                    <input
                      v-model="phone"
                      class="form-control col-md-7"
                      type="text"
                      placeholder="Phone"
                      required
                    />
                  </div>
                  <div class="row mb-3">
                    <input
                      type="email"
                      class="form-control"
                      v-model="email"
                      placeholder="Email"
                      required
                    />
                  </div>

                  <div class="row mb-3">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Bvn"
                      v-model="bvn"
                      required
                    />
                  </div>

                  <div class="row">
                    <p class="transaction-title" style="font-size:13px mt-5">
                      A password will be sent to your email, change upon first
                      login!
                    </p>
                    <input
                      type="submit"
                      value="Join Now"
                      class="btn btn-primary btn-block mb-4"
                    />
                  </div>
                </form>
              </div>

              <div></div>
            </div>
          </div>
          <div class="col-lg-6 man-col ">
            <div class>
              <div class="img-wrapper mt-3">
                <img
                  src="../../assets/images/joinimg.png"
                  alt
                  class="image-fluid man-img-2 d-none d-lg-block"
                />
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      firstname: "",
      lastname: "",
      phone: "",
      email: "",
      title: "",
      bvn: "",
      ShowLogin: false,
      ShowSignup: false
    };
  },
  methods: {
    Login() {
      this.$router.push("/dashboard");
    },
    Signup() {
      this.$router.push("/admin");
    }
  }
};
</script>

<style lang="scss" scoped>
.img-fluid-home {
  margin-left: 100px;
}

.content {
  margin-top: 100px;
  margin-left: 70px;
}

.main-wrapper {
  background: white;
  //border: 2px solid black;
}
.main-wrapper-1 {
  background: white;
  height: auto;
  overflow-x: hidden;
}
.middle {
  height: auto;
  position: relative;
  // border: 2px solid blue;
  z-index: 20;
  background: linear-gradient(white, rgb(229, 229, 229));
}
.body {
  background: white;
  //height: 100%;
  // overflow: hidden;
  width: 100%;
  //top: 60px;
  position: relative;
  //margin-right: 100px;
}
.nav-item {
  color: red !important;
}
.nav-toggle {
  background: #333 !important;
}
.text-color {
  color: $main-color;
  font-weight: 600;
}
.join {
  background: $main-color;
  border-radius: 10px;
  padding: 8px 15px;
  color: white;
}
.nav-bg {
  padding: 10px;
}
/* large diamond shape */
.diamond-wrapper {
  position: relative;
  margin-top: 0vh;
  margin-right: -350px;
  z-index: 0;
  width: 50%;
}

#diamond {
  width: 0;
  height: 0;
  border: 500px solid transparent;
  border-bottom-color: $main-color-light;
  position: relative;
  top: -500px;
}
#diamond:after {
  content: "";
  position: absolute;
  z-index: 1;
  left: -500px;
  top: 500px;
  width: 0;
  height: 0;
  border: 500px solid transparent;
  border-top-color: $main-color-light;
}
.man-img {
  height: 70%;
  width: 480px;
  position: relative;
  margin-right: -120;
  margin-top: -30px;
  z-index: 1;
}
.man-img-1 {
  height: 70%;
  width: 480px;
  position: relative;
  margin-right: 100px;
  margin-top: -30px;
  z-index: 1;
}
.man-img-2 {
  height: 100%;
  width: 370px;
  position: relative;
  margin-right: 100px;
  margin-top: -30px;
  z-index: 1;
}
.man-col {
  background: whitesmoke;
}
// .man-img-1::after {
//   content: "TMEEEEEEEEEEEEEEEE";
//   height: 70%;
//   width: 480px;
//   position: absolute;
//   margin-right: 100px;
//   top: -300px;
//   z-index: 1;
// }
.city-img {
  height: 350px;
  width: 500px;
  margin-right: 200px;
  position: relative;
}
.about-wrapper1 {
  padding: 50px 50px 10px 50px;
}
.about-wrapper2 {
  margin-right: 50px;
}
.about-text {
  border-bottom: 4px solid $main-color;
  width: 120px;
  padding: 0px 10px;
  border-radius: 1px;
}
input[type="submit"] {
  border-radius: 20px;
}
.email1,
input[type="password"] {
  border-radius: 0px;
  border: 0px;
  border-bottom: 2px solid gainsboro !important;
  // outline: none  !important;
}
.reset-password {
  color: $main-color;
  font-size: 14px;
}
input:focus {
  outline: none;
  box-shadow: 0px 0px;
}
#inp {
  width: 280px;
  height: 40px;
  border: 1px solid rgb(229, 229, 229);
  border-radius: 5px;
}
.phn {
  margin-left: 50px;
}
#inp1 {
  margin-left: 10px;
  width: 220px;
  height: 40px;

  border: 1px solid rgb(229, 229, 229);
  border-radius: 5px;
}
.lb {
  padding-top: 10px;
  color: rgb(15, 15, 15);
  font-size: 10px;
}
#title {
  height: 35px;
  border: 1px solid rgb(229, 229, 229);
  border-radius: 5px;
}
.img1 {
  margin-top: 150px;
  margin-right: 600px;
  height: 300px;
  width: 420px;
}
.welcome-text {
  font-size: 28px;
}

.tme-text {
  //border: 4px solid red;
  font-family: $SourceSansPro-SemiBold;
  position: absolute;
  width: auto;
  left: 200px;
  z-index: 200;
  top: 32vh;
}
.big {
  font-size: 50px;
  letter-spacing: 1px;
  .online {
    color: $main-color;
  }
}
.small {
  color: #333;
}

.city-img {
  opacity: 0.5;
  height: 200px;
  // width: 200px;
}
</style>
